@if (isActive) {
<div class="overlay">
    <div class="container">
        <h2 i18n>Zgoda na pliki cookie</h2>
        <p i18n>Cookies to małe pliki danych, które są przechowywane na Twoim urządzeniu podczas przeglądania stron
            internetowych. Używamy ich do poprawy działania serwisu, personalizacji treści, oraz analizy ruchu na
            stronie.
        </p>
        <div class="buttons">
            <button class="customize" (click)="customizeCookies()" i18n>Dostosuj</button>
            <button class="accept" (click)="acceptAllCookies()" i18n>Zezwól na wszystkie</button>
        </div>
    </div>
</div>
}
